export {ContentTextSpecsList} from './lib/content-text-specs-list';